import { moduleProviderFactory } from 'core/providers';
import { NikoPatientList, NikoPatientPreview } from 'application/niko-patient/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.niko-patient',
                pattern: '/niko-patients',
                children: [
                    {
                        name: 'master.app.main.niko-patient.list',
                        pattern: '',
                        tabTitle: 'NIKO_PATIENT.LIST.TITLE',
                        component: NikoPatientList,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'NIKO_PATIENT.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: "master.app.main.niko-patient.preview",
                        pattern: "/:id",
                        tabTitle: 'NIKO_PATIENT.LIST.TITLE',
                        component: NikoPatientPreview,
                        authorization: 'administrationSection.update',
                        data: {
                            back: "master.app.main.niko-patient.list",
                            crumbs: {
                                title: "NIKO_PATIENT.LIST.PATIENT",
                                route: 'master.app.main.niko-patient.preview'
                            }
                        },
                    },
                ]
            }
        ],
        menu: [
            {
                title: "MENU.NIKO",
                icon: "package",
                authorization: 'administrationSection.read',
                order: 6,
                subMenu: [
                    {
                        title: "MENU.PATIENT_MANAGEMENT",
                        authorization: 'administrationSection.read',
                        route: "master.app.main.niko-patient.list",
                        order: 1,
                    },
                ],
            },
        ],
    });
})();
